<template>
    <div id="share-btn-box">
        <button id="tweet-btn" @click="tweet()">折角なのでツイートする</button>
    </div>
</template>

<script>
export default {
    props:{
        text:{
            type:String,
            default: ()=>{
                return ''
            }
        }
    },
    computed:{
        shareURL(){
            return `https://twitter.com/intent/tweet?url=https://yubaba-7bad4.web.app/&text=${this.text}&hashtags=Firebase湯婆婆`
        }
    },
    methods:{
        tweet(){
            window.open(this.shareURL)
        }
    }
}
</script>

<style >
#share-btn-box{
    text-align: left;
    margin:auto;
    max-width: 700px;
    width: 90vw;
}

 #tweet-btn{
     color:white;
     background-color: rgb(94,170,222);
     border: none;
     border-radius: 3px;
 }
</style>